import { defineStore } from "pinia";
import { COMPLETION_NOT_STARTED } from "%/dynamic-component-editor/stores/completion-status-store";
import { COMPLETION_PREVIEW_STATES } from "%/dynamic-component-editor/helpers/completion-preview-states";

// Edit-time-only builder preview state; never persisted — production renders
// the story's real completion status, not this.
export const useCompletionPreviewStore = defineStore("completion-preview-store", {
  state: () => ({
    previewStatus: COMPLETION_NOT_STARTED,
  }),
  actions: {
    setPreviewStatus(status) {
      this.previewStatus = COMPLETION_PREVIEW_STATES.includes(status)
        ? status
        : COMPLETION_NOT_STARTED;
    },
  },
});
